import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getData as apiGetData } from 'api/Api'
import _ from 'lodash'
import { CardLink } from 'components/Link'
import {
  FormGroup,
  ControlLabel
} from 'react-bootstrap'
import { Modal } from 'components/Modal'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import SmartCard from 'components/SmartCard'
import Loader from 'components/Loader'
import classes from './DocumentReferences.module.scss'

export class DocumentReferences extends React.Component {
  static propTypes = {
    documentSourceId: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    cardComponent: PropTypes.func,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    cardComponent: SmartCard
  }

  constructor (props) {
    super(props)

    this.state = {
      boards: [],
      cardCount: 0,
      allCardCount: 0,
      isLoading: false,
      isLoaded: false
    }

    this.fetchReferences = this.fetchReferences.bind(this)
  }

  componentDidMount () {
    const { isLoading, isLoaded } = this.state

    if (!isLoading && !isLoaded) {
      this.fetchReferences()
    }
  }

  fetchReferences () {
    const { documentSourceId, url } = this.props

    this.setState({
      boards: [],
      cardCount: 0,
      allCardCount: 0,
      isLoading: true,
      isLoaded: false
    })

    apiGetData('DocumentReferences', {
      documentsSourceId: documentSourceId,
      url
    }).then(({ Cards, CardsCount }) => {
      const boards = _.orderBy(_.reduce(Cards.map(Card => {
        return {
          id: Card.CardId,
          name: Card.CardName,
          isArchived: Card.IsArchived,
          boardId: Card.BoardId,
          boardName: Card.BoardName
        }
      }), (result, card) => {
        if (!result[card.boardId]) {
          result[card.boardId] = {
            id: card.boardId,
            name: card.boardName,
            cards: []
          }
        }
        result[card.boardId].cards.push({
          id: card.id,
          name: card.name,
          isArchived: card.isArchived
        })
        return result
      }, {}), 'name')

      this.setState({
        boards,
        cardCount: Cards.length,
        allCardCount: CardsCount,
        isLoading: false,
        isLoaded: true
      })
    }).catch((error) => {
      if (error.code === 401) {
        this.setState({
          isLoading: false,
          isLoaded: true,
        })
      } else {
        throw error
      }
    })
  }

  handleClose = () => {
    const { onClose } = this.props

    onClose && onClose()
  }

  render () {
    const {
      name,
      cardComponent: CardComponent
    } = this.props
    const {
      isLoading,
      isLoaded,
      boards,
      cardCount,
      allCardCount
    } = this.state

    const unknownCardCount = allCardCount - cardCount

    return (
      <Modal
        onClose={this.handleClose}
      >
        <LeftSidebarView
          title={name}
        >
          <ViewBody>
            {boards.map(board =>
              <FormGroup key={board.id}>
                <ControlLabel>{board.name}</ControlLabel>
                <div>
                  {board.cards.map(card =>
                    <CardLink
                      key={card.id}
                      cardId={card.id}
                      className={'clear-link-style ' + classes.card}
                    >
                      <CardComponent
                        hover
                        id={card.id}
                        name={card.name}
                        isArchived={card.isArchived}
                        onClick={this.handleClose}
                      />
                    </CardLink>
                  )}
                </div>
              </FormGroup>
            )}
            {(isLoaded && unknownCardCount > 0) &&
              <FormGroup>
                <ControlLabel>
                  <FormattedMessage
                    id='DOCUMENT_REFERENCES_UNKNOWN_CARDS'
                    values={{
                      count: unknownCardCount
                    }} />
                </ControlLabel>
              </FormGroup>
            }
            {(isLoaded && !allCardCount) &&
              <div>
                <FormattedMessage id='DOCUMENT_REFERENCES_NONE' />
              </div>
            }
            {isLoading &&
              <Loader center />
            }
          </ViewBody>
        </LeftSidebarView>
      </Modal>
    )
  }
}

export default DocumentReferences
